/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomAmounts
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import formatCurrency from 'format-currency';
import { PRICE_TYPE } from '../../../constants';
import { DEVICES } from '../../../actions/Booking';
import { store } from '../../../Store';
import { convertCoinsToCurrency } from '../../../utils';

class RoomAmounts extends React.Component {
  getCurrency() {
    const { currency } = this.props;
    if (this.props.roundAmount) {
      return { ...currency, minimumFractionDigits: 0, maximumFractionDigits: 0 };
    }
    return currency;
  }

  getFormattedAmount(currency, priceType, amount) {
    if (!amount) {
      return null;
    }
    const value = priceType === PRICE_TYPE.TOTAL ? amount : (amount / this.props.nights);
    return formatCurrency(value, currency);
  }

  originalAmount(currency, priceType) {
    if (!this.props.showOriginal) {
      return null;
    }
    const originalAmount = this.props.amounts[currency.code].amount_before;
    return (
      <div className={`amount-price amount-price--crossed ${this.props.isDesktop
        ? 'amount-price-align-items-center' : ''}`}>
        <div className="amount-price__currency">
          {this.getFormattedAmount(currency, priceType, originalAmount)}
        </div>
      </div>
    );
  }

  renderCurrentAmount(currency, priceType, amount) {
    let amountDisplayed = amount;
    if (this.props.hotel != null) {
      if (this.props.hotel.percentage_total_taxes > 0) {
        amountDisplayed = amount - (amount * (this.props.hotel.percentage_total_taxes / 100));
      }
    }
    return (
      <span className="amount-price__currency pl-0 float-left">
        {this.getFormattedAmount(currency, priceType, amountDisplayed)}
      </span>
    );
  }

  getFinalBookingAmount(bookingAmount, currency) {
    let coinsApplied = 0;
    if (this.props.coinsApplied != null) {
      coinsApplied = this.props.coinsApplied;
    }
    const state = store.getState();
    // const CoinsToCurrency = convertCoinsToCurrency(coinsApplied, currency);
    let finalAmount = bookingAmount;

    if (coinsApplied !== 0) {
      const discount = state.cart.is_custom_currency_rate
        ? convertCoinsToCurrency(coinsApplied, currency) : coinsApplied;
        // Tuvimos que agregar al método convertCoinsToCurrency el parámetro opcional currency, ya que
        // va al store y toma el currency de state.booking.filterCurrency, lo cual no coincidiría
        // con el currency que se toma de la ip del usuario
      finalAmount = bookingAmount - discount;
    }
    return finalAmount;
  }

  currentAmount(currency, priceType) {
    if (this.props.doNotShowCurrent === true) {
      return null;
    }
    const isTotal = priceType === PRICE_TYPE.TOTAL;
    const { amount } = this.props.amounts[currency.code];
    const { showDescription, showTotalPrice } = this.props;
    let priceDesc = '';
    if (showDescription) {
      if (isTotal && !showTotalPrice) {
        priceDesc = this.context.t('total price');
      } else if (!isTotal) {
        priceDesc = this.context.t('per night');
      }
    }
    //TODOCANTIDADES
    //Cuando sean muchos cuartos, hacer que showFinalAmount sea false
    //Cuando sólo sea un cuarto, hacer que showFinalAmount sea true
    let amountToShow = amount;
    if (this.props.showFinalAmount === true) {
      amountToShow = this.getFinalBookingAmount(amount, currency);
    }

    if (this.props.forceCrossedAmount === true) {
      return (
        <div className={`amount-price amount-price--crossed ${this.props.isDesktop
          ? 'amount-price-align-items-center' : ''}`}>
          <div className="amount-price__currency">
            {this.getFormattedAmount(currency, priceType, amountToShow)}
          </div>
        </div>
      );
    }
    return (
      <div className={`amount-price ${this.props.isDesktop
        ? 'amount-price-align-items-center' : ''} ${this.props.isDesktop
        ? 'amount-price-align-items-center' : ''} amount-price--type${priceType}`}>
        {this.renderCurrentAmount(currency, priceType, amountToShow)}
        {priceDesc && <span className="flex flex-no-wrap pl-1 pt-3 amount-price__info">{priceDesc}</span>}
      </div>
    );
  }

  render() {
    const currency = this.getCurrency();
    return (
      <div className={`room-amounts ${this.props.isMobile ? 'displayBlock' : ''} ${this.props.extraClass || ''}`}>
        {this.props.children && <div className="room-amounts__title">{this.props.children}:</div>}
        {(this.props.showAmounts === 'PER_NIGHT' || this.props.showAmounts === 'BOTH')
        && <div className={`amount-price-block amount-price-block--bynight ${this.props.isMobile
          ? 'adjustMobile2' : ''}`}>
          {this.originalAmount(currency, PRICE_TYPE.AVG)}
          {this.currentAmount(currency, PRICE_TYPE.AVG)}
        </div>
        }
        {this.props.showTotalPrice && <div className="room-amounts__totalprice">{this.context.t('Total price')}:</div>}
        {(this.props.showAmounts === 'TOTAL' || this.props.showAmounts === 'BOTH')
        && <div className="amount-price-block">
          {this.originalAmount(currency, PRICE_TYPE.TOTAL)}
          {this.currentAmount(currency, PRICE_TYPE.TOTAL)}
          {this.props.showTax && <span className="amount-price__info">{this.context.t('* taxes included')}</span>}
        </div>
        }
        {this.props.renderSpecialBlock && this.props.renderSpecialBlock()}
      </div>
    );
  }
}

RoomAmounts.propTypes = {
  roundAmount: PropTypes.bool,
  showOriginal: PropTypes.bool,
  showTotalPrice: PropTypes.bool,
  showTax: PropTypes.bool,
  nights: PropTypes.number.isRequired,
  amounts: PropTypes.object.isRequired,
  currency: PropTypes.object.isRequired,
  extraClass: PropTypes.string,
  renderSpecialBlock: PropTypes.func,
  showDescription: PropTypes.bool,
  showFinalAmount: PropTypes.bool.isRequired,
  coinsApplied: PropTypes.number.isRequired,
  showAmounts: PropTypes.string,
  forceCrossedAmount: PropTypes.bool,
  doNotShowCurrent: PropTypes.bool,
};

RoomAmounts.defaultProps = {
  showAmounts: 'BOTH',
  forceCrossedAmount: false,
  doNotShowCurrent: false,
};

RoomAmounts.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  hotel: state.booking.hotel,
});

export default connect(mapStateToProps)(RoomAmounts);
